// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DateTimePickerActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { compose, withProps, withHandlers } from 'recompose';
import { Keys, UnitsAndSpansToAddOrSubtract } from './Izenda.DateTimeConstants';
import DateTimePickerModel from 'logic/models/Izenda.DateTimePickerModel';
import { find, isEmpty, isString, get } from 'lodash/fp';
import typeof Input from 'share/components/controls/Izenda.Input';
import classnames from 'classnames';

/**
 * On focus the input
 */
const onFocusInput = (props: Object) => (model: DateTimePickerModel) => () => {
  const { showPicker, disabled } = props;
  if (!disabled) {
    model.focusInput();
    showPicker();
  }
};

/**
 * On blur the input
 */
const onBlurInput = (props: Object) => (model: DateTimePickerModel, saveFunc: Function) => (e: Event) => {
  const { onBlur } = props;
  onBlur && onBlur(e, model);

  model.commitCurrentInputValue();
  saveFunc();
};

/**
 * Set input DOM Node
 */
const setInputDOMNode = () => (model: DateTimePickerModel) => (inputNode: Input) => {
  inputNode && model.setInputDOMNode(inputNode);
};

/**
 * On change input
 */
const onChangeInput = () => (model: DateTimePickerModel, saveFunc: Function) => (value: Event | string) => {
  let input = isString(value) ? value : get('target.value', value);
  model.changeInputValue(input) && saveFunc();
};

/**
 * On keydown input
 */
const onKeyDownInput = (props: Object) => (model: DateTimePickerModel, saveFunc: Function) => (e: Event) => {
  const { keyCode } = e;
  const { time, calendar, multi } = props;
  const { unit, span } = find({ calendar, time }, UnitsAndSpansToAddOrSubtract);

  switch (keyCode) {
    case Keys.UP:
      model.subtractDateTime(span, unit);
      saveFunc();
      break;
    case Keys.DOWN:
      model.addDateTime(span, unit);
      saveFunc();
      break;
    case Keys.ENTER: {
      model.commitCurrentInputValue();
      saveFunc();
      break;
    }
  }
};

export default compose(
  withProps((props: Object) => {
    const { visible, hidePicker, renderInContainer, calendar, time, className, multi } = props;
    const classes = classnames(className, { multi: multi });
    return {
      containerProps: {
        visible,
        hidePicker,
        renderInContainer,
        calendar,
        time,
        className: classes
      }
    };
  }),
  withHandlers({
    onKeyDownInput,
    onChangeInput,
    setInputDOMNode,
    onBlurInput,
    onFocusInput
  })
);



// WEBPACK FOOTER //
// ./ui/share/components/controls/DateTime/Izenda.DateTimePickerActions.js